import React from "react";
import CustomModal from "../ui/CustomModal";
import { CustomModalProps } from "../../types";
import { Button } from "antd";
import DownloadIcon from "../../assets/icons/DownloadIcon";
import useModal from "../../hooks/useModal";
import ReportRequestModalWithMonth from "../Report/ReportRequestModalWithMonth";
import {
  useDepartmentWiseSalaryReportMutation,
  useDisbursedPayslipMutation,
  useOvertimeSummaryMutation,
  usePayReportDetailsMutation,
  usePayReportMutation,
} from "../../features/report/reportApi";
import useError from "../../hooks/useError";

type ModalType =
  | "REPORT_REQUEST_DISBURSED"
  | "REPORT_REQUEST_OVERTIME"
  | "REPORT_REQUEST_PAY_REPORT"
  | "REPORT_REQUEST_PAY_REPORT_DETAILS"
  | "DEPARTMENT_WISE_REPORT_DETAILS";

export default function PayReportRequestButtonModal({
  ...rest
}: CustomModalProps) {
  const { open, handleClose, handleOpen } = useModal<undefined, ModalType>();
  const [
    disbursedPayslip,
    {
      isLoading: isGenerateLoading,
      isError: isGenerateError,
      error: generateError,
      isSuccess: isGenerateSuccess,
    },
  ] = useDisbursedPayslipMutation();
  const [
    overtimeSummary,
    {
      isLoading: isSummaryLoading,
      isError: isSummaryError,
      error: summaryError,
      isSuccess: isSummarySuccess,
    },
  ] = useOvertimeSummaryMutation();
  const [
    payReport,
    {
      isLoading: isPayReportLoading,
      isError: isPayReportError,
      error: payReportError,
      isSuccess: isPayReportSuccess,
    },
  ] = usePayReportMutation();
  const [
    payReportDetails,
    {
      isLoading: isPayReportDetailsLoading,
      isError: isPayReportDetailsError,
      error: payReportDetailsError,
      isSuccess: isPayReportDetailsSuccess,
    },
  ] = usePayReportDetailsMutation();
  const [
    departmentWiseSalaryReport,
    {
      isLoading: isDepartmentWiseSalaryLoading,
      isError: isDepartmentWiseSalaryError,
      error: departmentWiseSalaryError,
      isSuccess: isDepartmentWiseSalarySuccess,
    },
  ] = useDepartmentWiseSalaryReportMutation();
  useError(
    isGenerateError,
    generateError,
    "Disbursed payslip report request fail"
  );
  useError(
    isSummaryError,
    summaryError,
    "Overtime summary report request fail"
  );
  useError(isPayReportError, payReportError, "Salary report request fail");
  useError(
    isPayReportDetailsError,
    payReportDetailsError,
    "Salary report details request fail"
  );
  useError(
    isDepartmentWiseSalaryError,
    departmentWiseSalaryError,
    "Department wise salary report details request fail"
  );

  const handleDownloadRequest = (dates: {
    start_date: string;
    end_date: string;
  }) => {
    switch (open?.type) {
      case "REPORT_REQUEST_DISBURSED":
        disbursedPayslip({
          body: {
            name: "Disbursed payslip summary",
          },
          params: dates,
        });
        break;
      case "REPORT_REQUEST_OVERTIME":
        overtimeSummary({
          body: {
            name: "Overtime summary",
          },
          params: dates,
        });
        break;
      case "REPORT_REQUEST_PAY_REPORT":
        payReport({
          body: {
            name: "Salary report",
          },
          params: dates,
        });
        break;
      case "REPORT_REQUEST_PAY_REPORT_DETAILS":
        payReportDetails({
          body: {
            name: "Salary report details",
          },
          params: dates,
        });
        break;
      case "DEPARTMENT_WISE_REPORT_DETAILS":
        departmentWiseSalaryReport({
          body: {
            name: "Department wise salary report details",
          },
          params: dates,
        });
        break;
    }
  };

  return (
    <CustomModal
      title="Report Request"
      footer={null}
      width={550}
      // closeIcon={null}
      {...rest}
    >
      <ReportRequestModalWithMonth
        handleClose={handleClose}
        open={open?.open}
        handleSubmit={handleDownloadRequest}
        isLoading={
          isGenerateLoading ||
          isSummaryLoading ||
          isPayReportLoading ||
          isPayReportDetailsLoading ||
          isDepartmentWiseSalaryLoading
        }
        isSuccess={
          isGenerateSuccess ||
          isSummarySuccess ||
          isPayReportSuccess ||
          isPayReportDetailsSuccess ||
          isDepartmentWiseSalarySuccess
        }
      />
      <div className="grid grid-cols-2 gap-4">
        <Button
          onClick={() => handleOpen({ type: "REPORT_REQUEST_DISBURSED" })}
          className="download-button w-full"
          icon={<DownloadIcon />}
        >
          Disbursed payslip summary
        </Button>
        <Button
          onClick={() => handleOpen({ type: "REPORT_REQUEST_OVERTIME" })}
          className="download-button w-full"
          icon={<DownloadIcon />}
        >
          Overtime summary
        </Button>

        <Button
          onClick={() => handleOpen({ type: "REPORT_REQUEST_PAY_REPORT" })}
          className="download-button w-full"
          icon={<DownloadIcon />}
        >
          Download Pay Report
        </Button>
        <Button
          onClick={() =>
            handleOpen({ type: "REPORT_REQUEST_PAY_REPORT_DETAILS" })
          }
          className="download-button w-full"
          icon={<DownloadIcon />}
        >
          Download Pay Report Details
        </Button>

        <Button
          onClick={() => handleOpen({ type: "DEPARTMENT_WISE_REPORT_DETAILS" })}
          className="download-button w-full col-span-2"
          icon={<DownloadIcon />}
        >
          Download Department Wise Report Details
        </Button>
      </div>
    </CustomModal>
  );
}
